import { pbx_module_breadcrumbs } from './_module';
export const stats = pbx_module_breadcrumbs
  .extend('pbx.stats.type')
  .add('shared.breadcrumb.stats.title', { name: `pbx.stats.index` });

export const pbx_stats_breadcrumbs = [stats];
